import { AbsatzVorgabe, Money } from '@/domain/controlling/entities';
import { ContentWrapperCell } from './ContentWrapperCell';
import { AbsoluteNumberField, MoneyField } from '../../../components';
import { useTranslation } from 'react-i18next';
import { Separator } from './Separator';
import { useTagebuchEinstellungen } from '@/domain/controlling/hooks/useTagebuchEinstellungen';
import { FloatNumberField } from '../../../components/Fields/FloatNumberField';
import { useStandortContext } from '@/features/standortContext/StandortContext';

export function ProduktivitaetCell({
  umsatzZielproduktivitaet,
  absatzZielproduktivitaet,
}: {
  umsatzZielproduktivitaet: Money | undefined;
  absatzZielproduktivitaet: number | undefined;
}) {
  const { t } = useTranslation();
  const {
    currentStandort: { id: standortId },
  } = useStandortContext();
  const { umsatzplanungAnzeige: tagebuchAnzeige, tagebuchEinstellungen } =
    useTagebuchEinstellungen(standortId);

  return (
    <ContentWrapperCell>
      {tagebuchAnzeige !== 'ABSATZ_PRODUKTIVITAET' && (
        <MoneyField
          value={umsatzZielproduktivitaet}
          unit={t('domain.controlling.umsatzplanung.units.€/Std.')}
        />
      )}
      {tagebuchAnzeige === 'UMSATZ_ABSATZ_PRODUKTIVITAET' && <Separator />}
      {tagebuchAnzeige !== 'UMSATZ_PRODUKTIVITAET' &&
        (tagebuchEinstellungen.absatzProduktivitaet.absatzVorgabe ===
        AbsatzVorgabe.Stueck ? (
          <AbsoluteNumberField
            value={absatzZielproduktivitaet}
            unit={t('domain.controlling.umsatzplanung.units.Stk./Std.')}
          />
        ) : (
          <FloatNumberField
            value={absatzZielproduktivitaet}
            unit={t('domain.controlling.umsatzplanung.units.mpt')}
          />
        ))}
    </ContentWrapperCell>
  );
}
